<template>
  <div class="text-center mx-auto">
    <h1>Matricular aluno</h1>
    <v-divider></v-divider>
    <FormEnrolment
      :enrolment="enrolment"
      :is-new="true"
      @submitEnrolment="createEnrolment($event)"
    ></FormEnrolment>
    <v-dialog v-model="loading" persistent fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular
            indeterminate
            color="#00aab0"
            :size="100"
            :width="10"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AdminEnrolmentService from '@/services/admin-enrolment/admin-enrolment.service';
import FormEnrolment from '@/pages/admin/components/user/FormEnrolment';
import Enrolment from '@/models/enrolment';

const enrolmentService = new AdminEnrolmentService();

export default {
  name: 'CreateEnrolment',
  components: { FormEnrolment },
  data: () => ({
    userId: null,
    enrolment: new Enrolment(),
    loading: false,
    snackbar: false,
    snackbarText: '',
  }),
  mounted() {
    this.userId = this.$route.params?.userId ?? null;

    if (this.userId === null) {
      this.$router.push('/');
      return;
    }

    this.enrolment.user = this.userId;
  },
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    createEnrolment(enrolment) {
      this.loading = true;

      enrolmentService.create(enrolment)
        .then((response) => {
          this.showSnack(response.data.message);

          this.loading = false;
          this.$router.push(`/admin/user/${this.userId}/enrolments`);
        })
        .catch((err) => {
          this.loading = false;
          this.showSnack(err?.response?.data?.message ?? 'Falha ao criar matricula');
        });
    },
  }
};
</script>

<style scoped>

</style>
